import { UserState } from './types'

export const initialState: UserState = {
  user: null,
} as const
